import React from 'react';
import Portal from '@mui/material/Portal';
import Snackbar from '@mui/material/Snackbar';

/**
 * MUI Snackbar does not portal by default, so toasts can render under Dialog
 * backdrops (stacking contexts). Mounting via Portal to document.body fixes this.
 */
function PortalSnackbar(props) {
  return (
    <Portal>
      <Snackbar {...props} />
    </Portal>
  );
}

export default PortalSnackbar;
